import "../../css/Item.css";
import React, { useState } from "react";
import { useLanguage } from "./LanguageContext";
import { colorMaterial } from "../components/colorPaletteGroups";
import ColorPickerModal from "../modals/ColorPickerModal";
import { resolveMillingVariant } from "../../model/millingVariants";

export default function MillingSelector({ millingId, millingVariantId, width, height, colorId,
  allColors = [], allMillings = [], onChange, disabled, bg, rowHeight, fontSize,
  innerRef, onFocus, onKeyDown, styleOverride }) {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);
  const milling = allMillings.find((entry) => String(entry.millingId) === String(millingId));
  const color = allColors.find((entry) => String(entry.colorId) === String(colorId));
  let assigned = color?.millingAssignments;
  if (typeof assigned === "string") assigned = assigned.split(",").map((id) => id.trim()).filter(Boolean);
  const ids = new Set((Array.isArray(assigned) ? assigned : []).map((id) => String(id?.millingId ?? id)));
  const available = allMillings.filter((entry) => ids.has(String(entry.millingId)));
  const effective = milling && resolveMillingVariant(milling, millingVariantId, width, height);
  const change = (next, variantId = "", selectedColor) => {
    onChange({ millingId: next?.millingId ?? null, millingVariantId: variantId,
      ...(selectedColor ? { colorId: selectedColor.colorId } : {}) });
  };
  return <div className={`milling-dropdown${disabled ? " is-disabled" : ""}`}
    style={{ background: styleOverride?.background ?? bg, height: rowHeight, "--item-dropdown-font-size": fontSize == null ? undefined : `${fontSize}px` }} onClick={(event) => event.stopPropagation()}>
    <button ref={innerRef} onFocus={onFocus} onKeyDown={onKeyDown}
      style={styleOverride} type="button" disabled={disabled} onClick={() => setOpen(true)}
      className="milling-dropdown__trigger w-100 border-0 bg-transparent" aria-haspopup="dialog">
      <span style={{ color: styleOverride?.color }} className={`milling-dropdown__label text-start ${milling ? "has-value" : "is-placeholder"}`}>
        {milling ? `${milling.name}${effective && effective !== milling ? ` / ${effective.name}` : ""}` : t("selectMilling")}
      </span>
      {!disabled && <span className="milling-dropdown__caret">▾</span>}
    </button>
    {open && !disabled && <ColorPickerModal show initialMode="milling" colors={allColors} colorId={colorId} millings={allMillings} millingId={millingId} millingVariantId={millingVariantId || ""}
      initialMaterial={color ? colorMaterial(color) : milling ? colorMaterial(milling) : undefined}
      availableMillings={available} hasAssignment={!!color} onClose={() => setOpen(false)} onSelect={(selectedColor) => onChange({ colorId: selectedColor.colorId })} onSelectMilling={change} />}
  </div>;
}
